import React from 'react';

import {parseUri} from 'BenchlingUtil';
import PromoCodesView from 'growth/PromoCodesView';
import DatadogUtil from 'performance/DatadogUtil';
import {RouteBundle} from 'routing/RouteConstants';
import {renderReactElement} from 'util/RootReactRender';

export const GrowthRoutes: RouteBundle = {
  domain: 'growth',
  routes: [{urlPattern: 'account/promo-codes', handler: promoCodes}],
};

function promoCodes(): void {
  DatadogUtil.startRUMView('promo_codes');
  const {queryKey} = parseUri(window.location.href);
  renderReactElement(<PromoCodesView initialCode={queryKey.code} />);
}
